import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ariel-podzorski-profile-picture.webp'


const _hoisted_1 = { class: "hero-header" }
const _hoisted_2 = { href: "https://www.freelancermap.de/profil/ariel-podzorski" }

import { ref, onMounted, onUnmounted } from 'vue'
import { motion } from "motion-v"
import GradientTitle from "@/components/GradientTitle.vue"
import GradientButton from "@/components/GradientButton.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroSection',
  setup(__props) {

const heroSection = ref<HTMLElement>()
const heroContent = ref<HTMLElement>()

const handleScroll = () => {
  if (!heroContent.value || !heroSection.value) return

  const scrollY = window.scrollY
  const heroHeight = heroSection.value.offsetHeight
  const scrollProgress = Math.min(scrollY / (heroHeight * 0.6), 1)

  const opacity = Math.max(1 - scrollProgress * 1.2, 0)
  const offset = Math.round(scrollProgress * 100);

  heroContent.value.style.opacity = opacity.toString()
  heroContent.value.style.transform = `translate(-50%, calc(-50% - ${offset}px))`;
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", {
    class: "hero",
    ref_key: "heroSection",
    ref: heroSection
  }, [
    _createElementVNode("div", {
      class: "hero-content",
      ref_key: "heroContent",
      ref: heroContent
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(motion).div, {
          class: "profile-section",
          initial: { opacity: 0, y: 5 },
          whileInView: { opacity: 1, y: 0 },
          transition: { duration: 0.5 },
          inViewOptions: { once: true }
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Ariel Podzorski – Laravel Entwickler in Osnabrück",
              class: "profile-photo"
            }, null, -1)
          ])),
          _: 1,
          __: [0]
        }),
        _createVNode(_unref(motion).div, {
          class: "title-section",
          initial: { opacity: 0, y: 5 },
          whileInView: { opacity: 1, y: 0 },
          transition: { delay: 0.5, duration: 0.5 },
          inViewOptions: { once: true }
        }, {
          default: _withCtx(() => [
            _createVNode(GradientTitle, { text: "Ariel Podzorski" })
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(motion).div, {
        class: "description",
        initial: { opacity: 0, y: 5 },
        whileInView: { opacity: 1, y: 0 },
        transition: { delay: 1, duration: 0.5 },
        inViewOptions: { once: true }
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("p", null, "Senior Full-Stack Entwickler. Seit 7 Jahren baue ich skalierbare Webanwendungen mit Laravel und Vue.js.", -1),
          _createElementVNode("p", null, "Mein Fokus: Durchdachte Software-Architektur, Testbarkeit und wartbarer Code statt Quick-and-Dirty-Lösungen.", -1)
        ])),
        _: 1,
        __: [1]
      }),
      _createVNode(_unref(motion).div, {
        class: "portfolio-button",
        initial: { opacity: 0, y: 5 },
        whileInView: { opacity: 1, y: 0 },
        transition: { delay: 1.5, duration: 0.5 },
        inViewOptions: { once: true }
      }, {
        default: _withCtx(() => [
          _createElementVNode("a", _hoisted_2, [
            _createVNode(GradientButton, null, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Hire me ", -1)
              ])),
              _: 1,
              __: [2]
            })
          ])
        ]),
        _: 1
      })
    ], 512)
  ], 512))
}
}

})